import PortalIdParser from 'PortalIdParser';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import Contacts from 'in-meeting-experience-ui-components/components/contacts/Contacts';
import { LEGACY_DEAL_AMOUNT_CALCULATION } from 'products-ui-components/constants/Scopes';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { routes } from '../constants/routes';
import { associateObject, fetchAssociationSectionList, getCreatorAssociationPropertiesDefinitions, removeAssociationObject, updateAssociationObject } from '../data/api/associationsApi';
import { getAvatars } from '../data/api/avatarsApi';
import { createCrmObject, createCrmObjectBatch, getObject, searchObject } from '../data/api/crmV3Api';
import { calculatedProperties, getDealAmountCalculationProperty, getHomeCurrency } from '../data/api/dealsApi';
import { fetchPlaybooks, fetchRecommendedPlaybooks } from '../data/api/playbooksApi';
import { fetchCardProperties, fetchExternalOptions, fetchObjectCreationFields, fetchPropertiesDetails, validateProperty } from '../data/api/propertiesApi';
import { fetchRenderedContent, fetchUnrenderedContent, searchSnippets } from '../data/api/snippetsApi';
import useTracker from '../hooks/useTracker';
import { hubspotUserIdSelector, prosemirrorTrackerPropertiesSelector, scopesSelector } from '../slices/auth/selectors';
import { callObjectIdSelector, callObjectTitleSelector, isLoadingSelector as isLoadingCallObjectSelector } from '../slices/callObject/selectors';
import { canViewParticipantsSelector, meetingUUIDSelector } from '../slices/google/selectors';
import { dissociateContact, getMeetingParticipants, getMeetingParticipantsFromBackend, mapParticipantToContact } from '../slices/participants/actions';
import { isGoogleOutageSelector, isLoadingSelector, meetingParticipantsSelector } from '../slices/participants/selectors';
import { jsx as _jsx } from "react/jsx-runtime";
function ContactsPage() {
  const dispatch = useDispatch();
  const hubspotUserId = useSelector(hubspotUserIdSelector);
  const callObjectId = useSelector(callObjectIdSelector);
  const callObjectTitle = useSelector(callObjectTitleSelector);
  const meetingUUID = useSelector(meetingUUIDSelector);
  const meetingParticipants = useSelector(meetingParticipantsSelector);
  const isLoadingCallObject = useSelector(isLoadingCallObjectSelector);
  const scopes = useSelector(scopesSelector);
  const isGoogleOutage = useSelector(isGoogleOutageSelector);
  const isLoading = useSelector(isLoadingSelector);
  const prosemirrorTrackerProperties = useSelector(prosemirrorTrackerPropertiesSelector);
  const canViewParticipants = useSelector(canViewParticipantsSelector);
  const usageTracker = useTracker();
  const hasLegacyDealAmountCalculation = useMemo(() => scopes.includes(LEGACY_DEAL_AMOUNT_CALCULATION), [scopes]);
  const fetchParticipants = useCallback(() => {
    dispatch(getMeetingParticipants());
  }, [dispatch]);
  const getParticipantsFromBackend = useCallback(() => {
    dispatch(getMeetingParticipantsFromBackend());
  }, [dispatch]);
  const mapParticipant = useCallback(data => {
    dispatch(mapParticipantToContact({
      contactId: data.contact.id.toString(),
      participantId: data.participantId
    }));
  }, [dispatch]);
  const dissociateParticipant = ({
    participantId,
    contactId
  }) => {
    dispatch(dissociateContact({
      participantId,
      contactId
    }));
  };
  const intervalFetchMethod = setSkipRefresh => {
    dispatch(getMeetingParticipants({
      setSkipRefresh,
      intervalFetchAction: true
    }));
  };
  if (!callObjectId) {
    return /*#__PURE__*/_jsx(LoadingOverlay, {
      contextual: true
    });
  }
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "CONTACTS_PAGE_LOADED",
    children: /*#__PURE__*/_jsx(Contacts, {
      hubspotUserId: hubspotUserId,
      callObjectId: callObjectId,
      callObjectTitle: callObjectTitle,
      meetingUUID: meetingUUID,
      participants: meetingParticipants,
      portalId: PortalIdParser.getPortalIdFromPath(),
      featureTipsLink: "",
      methods: {
        fetchParticipants,
        getParticipantsFromBackend,
        mapParticipant,
        dissociateParticipant
      },
      apiWrapper: {
        snippets: {
          fetchRenderedContent,
          fetchUnrenderedContent,
          searchSnippets
        },
        playbooks: {
          fetchPlaybooks,
          fetchRecommendedPlaybooks
        },
        getObject,
        updateAssociationObject,
        calculateProperties: calculatedProperties,
        getMultiCurrencies: getHomeCurrency,
        getDealAmountSettings: getDealAmountCalculationProperty,
        fetchObjectCreationFields,
        fetchPropertiesDetails,
        createCrmObject,
        createCrmObjectBatch,
        validateProperty,
        getCreatorAssociationPropertiesDefinitions,
        fetchExternalOptions,
        searchObject,
        fetchCardProperties,
        fetchAssociationSectionList,
        associateObject,
        removeAssociationObject,
        getAvatars
      },
      isLoading: isLoadingCallObject || isLoading,
      isExternalOutage: isGoogleOutage,
      hasLegacyDealAmountCalculation: hasLegacyDealAmountCalculation,
      usageTracker: usageTracker,
      prosemirrorTrackerProperties: prosemirrorTrackerProperties,
      reconnectRoute: routes.reconnect,
      draftAttendees: [],
      myParticipantRole: canViewParticipants ? 'host' : 'attendee',
      canViewParticipants: canViewParticipants !== null && canViewParticipants !== void 0 ? canViewParticipants : false,
      intervalFetchMethod: intervalFetchMethod
    })
  });
}
export default ContactsPage;